var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15H10C9.448 15 9 15.45 9 16C9 16.55 9.448 17 10 17H22C22.552 17 23 16.55 23 16C23 15.45 22.552 15 22 15ZM30 28C30 29.1 29.104 30 28 30H4C2.896 30 2 29.1 2 28V4C2 2.9 2.896 2 4 2H28C29.104 2 30 2.9 30 4V28ZM28 0H4C1.791 0 0 1.79 0 4V28C0 30.21 1.791 32 4 32H28C30.209 32 32 30.21 32 28V4C32 1.79 30.209 0 28 0Z",
    fill: "#406CB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.8147b1ec4aea5d1cc4adfe9b909c1a95.svg";
export { ForwardRef as ReactComponent };